import { create } from 'zustand';
import type { Locale } from '@/api/types';

interface LocaleState {
  locale: Locale;
  setLocale: (l: Locale) => void;
}

export const RTL_LOCALES: ReadonlyArray<Locale> = ['ar'];

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: 'en',
  setLocale: (locale) => set({ locale }),
}));
